"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
function isCacheEmpty() {
    return store_1.default.recipientCache === null || store_1.default.recipientCache.length == 0;
}
exports.default = isCacheEmpty;
//# sourceMappingURL=isCacheEmpty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-cache/lib/utils/isCacheEmpty.js
// module id = 2781
// module chunks = 2 3 4 45